import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
	TruckSearchTable,
	CarrierTable,
	ProjectCarrierMapDTO,
	IS_EMPTY,
	IS_NOT_EMPTY,
} from 'cargo-chief-commons';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SharedService } from '@service/shared/shared.service';
import { QUALITY_SCORE_DISPLAY } from '@domain/constants/app-variables';
import { environment } from '@environment/environment';

@Component({
	selector: 'app-quality-stats',
	templateUrl: './quality-stats.component.html',
	styleUrls: ['./quality-stats.component.scss'],
})
export class QualityStatsComponent implements OnInit, OnChanges {
	@Input() capacitySearchList: Array<TruckSearchTable> = null;
	@Input() carriersList: Array<CarrierTable> = null;
	@Input() projectCarrierMapsList: Array<ProjectCarrierMapDTO> = null;

	@Input() capacitySearchResult: boolean = false;
	@Input() engagedProjectCarrierMap: boolean = false;
	@Input() procuredProjectCarrierMap: boolean = false;
	@Input() carriersNetwork: boolean = false;

	qualityStats = {
		high: null,
		medium: null,
		low: null,
	};

	constructor(
		public cargochief: Cargochief,
		private sharedService: SharedService
	) {}

	ngOnInit() {}

	ngOnChanges(changes: SimpleChanges): void {
		this.initialiseStats();
		if (this.capacitySearchResult && this.capacitySearchList) {
			this.capacitySearchList?.forEach((search) => {
				this.updateQualityStats(search.ccScore, search.active);
			});
		} else if (this.engagedProjectCarrierMap || this.procuredProjectCarrierMap) {
			this.projectCarrierMapsList?.forEach((procuredCarrier) => {
				let score = null;
				const acm = procuredCarrier?.carrier?.accountCarrierMaps.find(
					(acm) => acm.accountId == this.cargochief.ACCOUNT_ID
				);
				score = acm?.ccScore;
				if (
					IS_EMPTY(acm?.vettingOverallDisplay) &&
					IS_NOT_EMPTY(procuredCarrier?.carrier?.vettingOverallDisplay)
				) {
					score = procuredCarrier?.carrier.ccScore;
				}
				this.updateQualityStats(score, procuredCarrier?.carrier?.active);
			});
		} else if (this.carriersNetwork) {
			this.carriersList?.forEach((carrier) => {
				this.updateQualityStats(carrier.ccScore, carrier.active);
			});
		}
	}

	updateQualityStats(ccScore, active) {
		const quality = this.sharedService.getCarrierScoreToDisplay(ccScore, active);
		if (quality === QUALITY_SCORE_DISPLAY.HIGH) {
			this.qualityStats.high += 1;
		} else if (quality === QUALITY_SCORE_DISPLAY.MEDIUM) {
			this.qualityStats.medium += 1;
		} else if (quality === QUALITY_SCORE_DISPLAY.LOW) {
			this.qualityStats.low += 1;
		}
	}

	initialiseStats() {
		this.qualityStats.high = 0;
		this.qualityStats.medium = 0;
		this.qualityStats.low = 0;
	}
}
